import { render, staticRenderFns } from "./boton_politicas.vue?vue&type=template&id=1c06c4ec&scoped=true&"
import script from "./boton_politicas.vue?vue&type=script&lang=js&"
export * from "./boton_politicas.vue?vue&type=script&lang=js&"
import style0 from "./boton_politicas.vue?vue&type=style&index=0&id=1c06c4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c06c4ec",
  null
  
)

export default component.exports